import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const doLogin = async (em, pw) => {
    setLoading(true);
    const res = await login(em ?? email, pw ?? password);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name}`);
      navigate(res.user.role === "PLATFORM_ADMIN" ? "/admin" : `/r/${res.user.restaurant_id}/dashboard`);
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1728501650832-57bafbf10a37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzgyODkwMjIwfDA&ixlib=rb-4.1.0&q=85"
          alt="Restaurant interior"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/40" />
        <div className="absolute bottom-0 p-12 text-white">
          <h2 className="font-display text-4xl font-extrabold leading-tight">Never miss a call.<br />Never miss an order.</h2>
          <p className="mt-4 text-white/90 max-w-md">AI phone receptionist, allergen-aware ordering, dine-in & takeaway management — all in one place for busy service.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-background">
        <div className="w-full max-w-md">
          <div className="flex flex-col items-center text-center mb-10">
            <img src="/dineflo-logo.png" alt="DineFlo" data-testid="brand-logo"
              className="h-28 w-28 rounded-3xl object-contain bg-black ring-1 ring-border shadow-lg" />
            <span className="font-display font-extrabold text-4xl tracking-tight mt-5" data-testid="brand-name">DineFlo</span>
            <p className="text-muted-foreground mt-2">AI voice receptionist & order management.</p>
          </div>
          <h1 className="font-display text-2xl font-bold mb-6 text-center">Sign in</h1>

          <form
            onSubmit={(e) => { e.preventDefault(); doLogin(); }}
            className="space-y-4"
          >
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email}
                onChange={(e) => setEmail(e.target.value)} className="h-12 mt-1.5" placeholder="you@restaurant.com" required />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="login-password" value={password}
                onChange={(e) => setPassword(e.target.value)} className="h-12 mt-1.5" placeholder="••••••••" required />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 active:scale-95 transition-transform">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
